import {CPSConstants} from "commonUtils/enumerations";

export const FormButtonStyle = {
  buttonStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#233274",
    color: "#FFFFFF",
    textTransform: "capitalize",
    fontSize: CPSConstants.FONTREMTEXT,
  },
};
